import * as React from 'react';

import {FieldArray} from 'redux-form';

import {FormField} from 'shells/form/form-field';

import type {TagType} from 'nutshell-graphql-types';

import {TagSelect} from './tag-select';

type Props = {
    tagType: TagType;
    shouldAnd?: boolean;
};

export function AddTagForm(props: Props) {
    return (
        <FormField innerId='tags' label='Which tag?'>
            <FieldArray
                name='tags'
                component={TagSelect}
                tagType={props.tagType}
                shouldAnd={props.shouldAnd}
            />
        </FormField>
    );
}
